export const SET_SIDE_PANEL_CONTENT = 'SET_SIDE_PANEL_CONTENT';
export const SET_SIDE_PANEL_IS_OPEN = 'SET_SIDE_PANEL_IS_OPEN';
export const SIDE_PANEL_CLEAN_UP = 'SIDE_PANEL_CLEAN_UP';
export const UPDATE_SIDE_PANEL_DATA = 'UPDATE_SIDE_PANEL_DATA';
export const SET_SIDE_PANEL_WIDTH = 'SET_SIDE_PANEL_WIDTH';
export const SET_SIDE_PANEL_PRESERVE_MIN_WIDTH =
  'SET_SIDE_PANEL_PRESERVE_MIN_WIDTH';
export const UPDATE_SIDE_PANEL_PENDING_PROPERTIES =
  'UPDATE_SIDE_PANEL_PENDING_PROPERTIES';

// COR-76625:
// Dispatched by `WFFormWidgetViewImpl.java` to act as a proxy for `MessagingListBody.jsx`s
// `setNextSidePanelMessageContent` state method. Will be used in tandem with `IS_FORM_DIRTY`
// to show a chicken exit if dashboard form is dirty and to load the `next` form on confirm.
export const SET_GWT_NEXT_SIDE_PANEL_MESSAGE_CONTENT =
  'SET_GWT_NEXT_SIDE_PANEL_MESSAGE_CONTENT';
export const CLEAR_GWT_NEXT_SIDE_PANEL_MESSAGE_CONTENT =
  'CLEAR_GWT_NEXT_SIDE_PANEL_MESSAGE_CONTENT';

export const clearGWTNextSidePanelMessageContent = () => ({
  type: CLEAR_GWT_NEXT_SIDE_PANEL_MESSAGE_CONTENT,
});

export const setSidePanelContent = content => ({
  type: SET_SIDE_PANEL_CONTENT,
  payload: content,
});

export const updateSidePanelData = data => ({
  type: UPDATE_SIDE_PANEL_DATA,
  payload: data,
});

export const setSidePanelIsOpen = isOpen => ({
  type: SET_SIDE_PANEL_IS_OPEN,
  payload: isOpen,
});

export const setSidePanelWidth = width => ({
  type: SET_SIDE_PANEL_WIDTH,
  payload: width,
});

export const setSidePanelPreserveMinWidth = preserveMinWidth => ({
  type: SET_SIDE_PANEL_PRESERVE_MIN_WIDTH,
  payload: preserveMinWidth,
});

export const cleanup = () => ({
  type: SIDE_PANEL_CLEAN_UP,
});

export const IS_FORM_DIRTY = 'IS_FORM_DIRTY';
export const SHOW_CHICKEN_EXIT = 'SHOW_CHICKEN_EXIT';

export function setIsFormDirty(isDirty) {
  return {
    type: IS_FORM_DIRTY,
    payload: isDirty,
  };
}

export function setShowChickenExit(showChickenExit) {
  return {
    type: SHOW_CHICKEN_EXIT,
    payload: showChickenExit,
  };
}

export const SET_SIDE_PANEL_DIRTY = 'SET_SIDE_PANEL_DIRTY';

export function setIsSidePanelDirty(isDirty) {
  return {
    type: SET_SIDE_PANEL_DIRTY,
    payload: isDirty,
  };
}

export const SET_SIDE_PANEL_BACK_BUTTON = 'SET_SIDE_PANEL_BACK_BUTTON';

export function setBackButton(label, action) {
  return {
    type: SET_SIDE_PANEL_BACK_BUTTON,
    payload: {
      onBackNav: action,
      backButtonLabel: label,
    },
  };
}

export const ACCEPT_PENDING_SIDE_PANEL_CONTENT =
  'ACCEPT_PENDING_SIDE_PANEL_CONTENT';
export const REJECT_PENDING_SIDE_PANEL_CONTENT =
  'REJECT_PENDING_SIDE_PANEL_CONTENT';

export function handleSidePanelContentUpdate(response = false) {
  if (response) {
    return {
      type: ACCEPT_PENDING_SIDE_PANEL_CONTENT,
    };
  }
  return {
    type: REJECT_PENDING_SIDE_PANEL_CONTENT,
  };
}

export const SET_SIDE_PANEL_TYPE = 'SET_SIDE_PANEL_TYPE';

export const setSidePanelType = type => ({
  type: SET_SIDE_PANEL_TYPE,
  payload: type,
});

export const SET_SIDE_PANEL_CONTAINER_CLASSNAME =
  'SET_SIDE_PANEL_CONTAINER_CLASSNAME';

export const setContainerClassName = className => ({
  type: SET_SIDE_PANEL_CONTAINER_CLASSNAME,
  payload: className,
});
